/* Your Legacy — fixes and interactions for the left column of product pages (v2, 17 Oct 2026).

   1. Images keep their `srcset` + `sizes` (the browser picks the right size for the screen and the
      hero is discoverable from the HTML, which is what LCP needs). Scripts that switch the main
      image call window.CBCGallery.setPic(img, url): it updates src AND srcset together, so the
      change is visible — before, srcset was stripped and every switch forced the 1200 px file.
   2. The other gallery images are preloaded one at a time, at the size the browser actually chose
      for the main image (not blindly 1200 px) — only once the visitor touches, hovers or focuses
      the gallery (21 Oct 2026). Before, ~1.2 MB of photos downloaded on every visit, even for
      visitors who never opened the gallery.
   3. Previous / next arrows on the main image.
   4. Up / down arrows on the thumbnail column.
   5. The badge only shows on the first image.
   6. Review carousel: chevrons, auto-scroll and swipe. Auto-scroll starts after the page `load`
      event (21 Oct 2026): a scroll while the page is still loading makes Chrome stop measuring
      Largest Contentful Paint (PageSpeed then reports NO_LCP).

   Performance: no layout read right after a DOM write. All writes happen first; reads are
   batched into ONE animation frame, and sizes are tracked by ResizeObserver. No forced reflow.
   Labels follow <html lang>: English by default, Spanish on /es pages. */
(function () {
  "use strict";

  var ES = /^es/i.test(document.documentElement.lang || "");
  var L = ES
    ? { prev: "Imagen anterior", next: "Imagen siguiente", tUp: "Miniaturas anteriores", tDown: "Miniaturas siguientes", rPrev: "Reseña anterior", rNext: "Reseña siguiente" }
    : { prev: "Previous image", next: "Next image", tUp: "Previous thumbnails", tDown: "Next thumbnails", rPrev: "Previous review", rNext: "Next review" };
  var PATH_LEFT = "M15 6l-6 6l6 6";
  var PATH_RIGHT = "M9 6l6 6l-6 6";
  var PATH_UP = "M6 15l6 -6l6 6";
  var PATH_DOWN = "M6 9l6 6l6 -6";
  var REVIEW_DELAY = 5000;
  var WIDTHS = [600, 900, 1200];

  /* Read queue: run together on the next frame, after every write. */
  var readQueue = [], rafPending = false;
  function measure(fn) {
    readQueue.push(fn);
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      var q = readQueue; readQueue = [];
      var writes = q.map(function (f) { return f(); });
      writes.forEach(function (w) { if (typeof w === "function") w(); });
    });
  }

  function scopeOf(root) { return root && root.querySelectorAll ? root : document; }

  /* Shopify CDN URLs carry the size as ?width=N (or &width=N). */
  function withWidth(url, w) { return /([?&])width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, "$1width=" + w) : url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w; }
  function baseOf(url) { return url.replace(/([?&])width=\d+/, "$1").replace(/[?&]$/, ""); }
  function chosenWidth(img) {
    var m = /[?&]width=(\d+)/.exec(img.currentSrc || img.src || "");
    return m ? +m[1] : 1200;
  }
  /* Switch an image to another picture: src and srcset together, nothing when it is already it. */
  function setPic(img, url) {
    if (!img || !url) return false;
    var base = baseOf(url);
    if (img.getAttribute("data-pic") === base) return false;
    img.setAttribute("data-pic", base);
    if (img.hasAttribute("srcset")) {
      img.srcset = WIDTHS.map(function (w) { return withWidth(url, w) + " " + w + "w"; }).join(", ");
    }
    img.src = withWidth(url, 1200);
    return true;
  }
  window.CBCGallery = { setPic: setPic, withWidth: withWidth };

  function markMain(root) {
    var imgs = scopeOf(root).querySelectorAll("img[data-main]");
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].getAttribute("data-pic")) imgs[i].setAttribute("data-pic", baseOf(imgs[i].getAttribute("src") || ""));
    }
  }

  function thumbsOf(gal) { return Array.prototype.slice.call(gal.querySelectorAll("[data-thumb]")); }

  function preload(gal) {
    if (gal.getAttribute("data-cbc-pre")) return;
    gal.setAttribute("data-cbc-pre", "1");
    var main = gal.querySelector("img[data-main]");
    var w = main ? chosenWidth(main) : 900;
    var list = thumbsOf(gal), i = 0;
    function next() {
      if (i >= list.length) return;
      var img = new Image();
      img.decoding = "async";
      img.src = withWidth(list[i++].src, w);
      if (img.decode) img.decode().then(next, next); else { img.onload = next; img.onerror = next; }
    }
    next();
  }
  /* Preload on the first sign of interest in the gallery, never on page load. */
  function schedulePreload(gal) {
    var run = function () { preload(gal); };
    ["pointerenter", "touchstart", "focusin"].forEach(function (t) {
      gal.addEventListener(t, run, { once: true, passive: true });
    });
  }

  /* Pure write: no geometry read. */
  function syncKicker(gal) {
    var kicker = gal.querySelector(".gal-main .kicker");
    if (!kicker) return;
    var list = thumbsOf(gal);
    if (list.length < 2) return;
    var active = 0;
    for (var i = 0; i < list.length; i++) if (list[i].hasAttribute("data-active")) { active = i; break; }
    kicker.style.display = active === 0 ? "" : "none";
  }

  function makeButton(cls, flag, path, size, label) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = cls;
    if (flag) b.setAttribute(flag, "");
    b.setAttribute("aria-label", label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none"' +
      ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"' +
      ' aria-hidden="true"><path d="' + path + '"/></svg>';
    return b;
  }

  function addImageNav(gal) {
    if (gal.getAttribute("data-cbc-nav")) return;
    var main = gal.querySelector(".gal-main");
    if (!main || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-nav", "1");

    function step(delta) {
      var list = thumbsOf(gal);
      if (list.length < 2) return;
      var i = 0;
      for (var k = 0; k < list.length; k++) if (list[k].hasAttribute("data-active")) i = k;
      var n = (i + delta + list.length) % list.length;
      list[n].click();
      if (list[n].scrollIntoView) list[n].scrollIntoView({ block: "nearest", inline: "nearest" });
      syncKicker(gal);
    }
    var prev = makeButton("gal-nav", "data-prev", PATH_LEFT, 15, L.prev);
    var next = makeButton("gal-nav", "data-next", PATH_RIGHT, 15, L.next);
    prev.addEventListener("click", function (e) { e.preventDefault(); step(-1); });
    next.addEventListener("click", function (e) { e.preventDefault(); step(1); });
    main.appendChild(prev);
    main.appendChild(next);

    gal.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest || !e.target.closest("[data-thumb], .thumb")) return;
      window.setTimeout(function () { syncKicker(gal); }, 0);
    });
  }

  function addThumbScroller(gal) {
    if (gal.getAttribute("data-cbc-thumbnav")) return;
    var strip = gal.querySelector(".gal-thumbs");
    if (!strip || thumbsOf(gal).length < 2) return;
    gal.setAttribute("data-cbc-thumbnav", "1");

    var up = makeButton("gal-thumbnav", "data-thumbs-up", PATH_UP, 14, L.tUp);
    var down = makeButton("gal-thumbnav", "data-thumbs-down", PATH_DOWN, 14, L.tDown);
    up.hidden = down.hidden = true;
    gal.appendChild(up);
    gal.appendChild(down);

    var clientH = 0;
    function sync() {
      measure(function () {
        var max = strip.scrollHeight - strip.clientHeight, top = strip.scrollTop;
        clientH = strip.clientHeight;
        return function () {
          var scrollable = max > 2;
          up.hidden = !scrollable || top <= 2;
          down.hidden = !scrollable || top >= max - 2;
        };
      });
    }
    function page(dir) {
      var amount = Math.max(86, Math.round(clientH * 0.8));
      if (strip.scrollBy) strip.scrollBy({ top: dir * amount, behavior: "smooth" });
      else strip.scrollTop += dir * amount;
    }
    up.addEventListener("click", function (e) { e.preventDefault(); page(-1); });
    down.addEventListener("click", function (e) { e.preventDefault(); page(1); });
    strip.addEventListener("scroll", sync, { passive: true });
    if ("ResizeObserver" in window) new ResizeObserver(sync).observe(strip);
    else window.addEventListener("resize", sync);
    window.addEventListener("load", sync);
    sync();
  }

  function addReviewCarousel(host) {
    if (host.getAttribute("data-cbc-rev")) return;
    var track = host.querySelector(".hr-track");
    if (!track) return;
    var slides = track.querySelectorAll(".hr-slide");
    if (slides.length < 2) return;
    host.setAttribute("data-cbc-rev", "1");

    var idx = 0, paused = false, width = 0;
    if ("ResizeObserver" in window) {
      new ResizeObserver(function (en) { width = en[0].contentRect.width; }).observe(track);
    } else {
      measure(function () { width = track.clientWidth; });
    }
    function goTo(n) {
      idx = (n + slides.length) % slides.length;
      if (!width) return;
      if (track.scrollTo) track.scrollTo({ left: idx * width, behavior: "smooth" });
      else track.scrollLeft = idx * width;
    }
    track.addEventListener("scroll", function () {
      if (width) idx = Math.round(track.scrollLeft / width);
    }, { passive: true });

    var prev = makeButton("hr-prev", null, PATH_LEFT, 14, L.rPrev);
    var next = makeButton("hr-next", null, PATH_RIGHT, 14, L.rNext);
    prev.addEventListener("click", function (e) { e.preventDefault(); goTo(idx - 1); });
    next.addEventListener("click", function (e) { e.preventDefault(); goTo(idx + 1); });
    host.appendChild(prev);
    host.appendChild(next);

    host.addEventListener("pointerenter", function () { paused = true; });
    host.addEventListener("pointerleave", function () { paused = false; });
    host.addEventListener("touchstart", function () { paused = true; }, { passive: true });
    host.addEventListener("touchend", function () { window.setTimeout(function () { paused = false; }, 6000); }, { passive: true });

    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    var autoplay = function () { window.setInterval(function () { if (!paused && !document.hidden) goTo(idx + 1); }, REVIEW_DELAY); };
    if (document.readyState === "complete") autoplay(); else window.addEventListener("load", autoplay, { once: true });
  }

  function init(root) {
    markMain(root);
    var scope = scopeOf(root);
    var gals = scope.querySelectorAll(".gal");
    for (var i = 0; i < gals.length; i++) {
      addImageNav(gals[i]);
      addThumbScroller(gals[i]);
      syncKicker(gals[i]);
      schedulePreload(gals[i]);
    }
    var revs = scope.querySelectorAll("[data-review-carousel]");
    for (var j = 0; j < revs.length; j++) addReviewCarousel(revs[j]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
